export default __webpack_public_path__ + "static/media/floorplans3.9ae98c4b.jpg";